import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VContent } from 'vuetify/lib/components/VContent';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VAppBar,{attrs:{"app":""}},[_c(VToolbarTitle,{staticClass:"headline text-uppercase"},[_c('span',[_vm._v("La Xicra")])])],1),_c(VContent,{staticClass:"cc"},[_c('Home')],1),_c(VFooter,{attrs:{"app":""}},[_vm._v("\n    FOOTET\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }